module.exports = {
    stateLocations: {
      Analytics: {
        Base: "Analytics",
        Url: "Url",
      },
      Conversation: {
        isUserLoggedIn: "IsUserLoggedIn",
        receivedResponseWatches : [
            "Conversation.ReceivedResponse",
            "Conversation.UploadHistory.ReceivedResponse",
            "History.ReceivedResponse",
        ],
        stagedInputWatches: [
            "Conversation.UploadHistory.StagedInput",
            "History.StagedInput",
            "Window.Input.StageLocation",
            "Window.StagedEvent",
            "Conversation.DisplayLinks.StagedInput",
            "WelcomeUser.StagedEvent",
            "VersionReporter.StagedEvent",
            "AutoNav.StagedEvent",
        ],
         // live chat foundation
         Base: 'Conversation',
         processedResponse: 'ProcessedResponse',
         responseProcessing: 'ResponseProcessing',
      },
      FormInteraction:  {
        Base: "FormInteraction",
        EntryId: "EntryId",
      },
      PersistentStorage: {
        "watches": {
            "NITAlme" : [
                "CommandAction.PageLoadActions",
                "Conversation.SessionId",
                "Conversation.AccessKey",
                "Conversation.UserId",
                "Window.Position",
                "Window.Size",
                "Window.IsMinimized",
                "Conversation.IsActiveSession",
                "FormInteraction.EntryId",
                "Survey.visible",
                "Survey.EntryId",
                "Window.IsSound",
                "TTS.LastPrvUrl",
                "TTS.PlayPrvOnNav",
                "LiveChat.SessionState",
            ],
        },
      },
      History: {
        Base: 'History',
        initializeCompleted: 'InitializeCompleted',
        Messages: 'HistoryMessages',
    },
    LiveChat: {
            ProcessedResponse: "ProcessedResponse",
            SurveyUrl: "SurveyUrl",
            IsChatAvailable: "IsChatAvailable",
            DisplayMessageReceivedWait: "DisplayMessageReceivedWait",
            SendMessageExtStaging: {
                Base: "SendMessageExtStaging",
                ReceivedResponse: "ReceivedResponse",
            },
            AvailabilityStaging: {
                Base: "AvailabilityStaging",
            },
            MinimizedCount: "MinimizedCount",
        Base: 'LiveChat',
        operatorData: 'OperatorData',
        operatorTyping: 'OperatorTyping',
        sessionState: 'SessionState',
        stagedEvent: 'StagedEvent',
    },
      Window: {
        currentTree: "CurrentTree",
      },
    },
};



// WEBPACK FOOTER //
// ./settings/state-locations.js